import {
  Component,
  EventEmitter, input,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import {
  CounterInitModel,
  CounterInitVariables,
  CounterModel,
  CounterVariables,
} from '../../../../../models/email-template/counter.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-counter',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        NgbDropdownModule,
        PinComponent,
    ],
    templateUrl: './counter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './counter.component.scss'
})
export class CounterComponent extends BaseComponent {
  @Input() block: CounterModel = new CounterInitModel();

  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new CounterInitVariables()
    }
  }

  // Placeholders:
  countdownAltPlaceholder: string = 'Enter Countdown Alt Text';
  countdownImagePlaceholder: string = 'Countdown Image';
  countdownLinkPlaceholder: string = 'Enter Countdown Redirect Link';

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  // Generalized change handler method
  onChange(value: any, fieldName: keyof CounterVariables): void {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof CounterVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
